import { VideoControlType } from '@atlassian/learning-components';

export const FIELD_ID = 'courseId';
export const LEARNING_PATH_DISCLAIMER_TEXT =
  'The availability of features and functionality shown in this learning path depends on your product subscription. To learn more about Atlassian product subscriptions, ';
export const COURSE_DISCLAIMER_TEXT =
  'The availability of features and functionality shown in this course depends on your product subscription. To learn more about Atlassian product subscriptions, ';
export const CUSTOM_TABLET_WIDTH = 1200;
export const MOBILE_CONTROLS: VideoControlType[] = ['play-small', 'play', 'progress', 'mute', 'settings', 'fullscreen'];
export const DESKTOP_CONTROLS: VideoControlType[] = [
  'play-small',
  'play',
  'progress',
  'rewind',
  'fast-forward',
  'mute',
  'settings',
  'fullscreen',
];
